import script from "./InputCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./InputCheckbox.vue?vue&type=style&index=0&id=48d3354a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d3354a"]])

export default __exports__